var AlertConditionType = {
    Or: 1,
    And:  2
 }
 export default AlertConditionType;